import {
	Directive,
	ElementRef,
	OnInit,
	Renderer2
} from '@angular/core';

import { ApiStatus } from '../models/api';
import { ApiService } from '../services/api.service';

const DISABLED = 'disabled';
const APP_DISABLED = 'app-disabled';
const TAB_INDEX = 'tabindex';
const TAG_ANCHOR = 'a';

@Directive({
    selector: '[mwpAppAutoDisable]',
    standalone: false
})
export class AppDisableDirective implements OnInit {
	private mwpAppDisable: boolean;

	constructor(
		private eleRef: ElementRef,
		private renderer: Renderer2,
		private apiService: ApiService,
	) {
	}

	ngOnInit() {
		this.apiService.$ApiStatus.subscribe((apiStatus: ApiStatus) => {
			this.mwpAppDisable = apiStatus.isActive;
			this.disableElement(this.eleRef.nativeElement);
		});
	}

	private disableElement(element: any) {
		if (this.mwpAppDisable) {
			this.disable(element);
		} else {
			this.enable(element);
		}

		if (element.children) {
			for (let ele of element.children) {
				this.disableElement(ele);
			}
		}
	}

	private disable(element: any): void {
		if (!element.hasAttribute(DISABLED)) {
			this.renderer.setAttribute(element, APP_DISABLED, '');
			this.renderer.setAttribute(element, DISABLED, 'true');
			document.documentElement.setAttribute(APP_DISABLED, '');

			if (element.tagName.toLowerCase() === TAG_ANCHOR)
				this.renderer.setAttribute(element, TAB_INDEX, '-1');
		}
	}

	private enable(element: any): void {
		if (element.hasAttribute(APP_DISABLED)) {
			if (element.getAttribute('disabled') !== '')
				this.renderer.removeAttribute(element, DISABLED);

			this.renderer.removeAttribute(element, APP_DISABLED);
			document.documentElement.removeAttribute(APP_DISABLED);
			if (element.tagName.toLowerCase() === TAG_ANCHOR)
				this.renderer.removeAttribute(element, TAB_INDEX);
		}
	}
}
